import { api } from "@shared/api/client";
import type { CalidadNcpFirma, CalidadNcpFirmaTipo } from "../../../standards/iso-9001-14001/sections/incidencias/types/calidad";

export type NcpSignatureRequestStatus = "pendiente" | "firmada" | "caducada" | "invalidada";

export type NcpSignatureRequest = {
  id: number;
  tipo: CalidadNcpFirmaTipo;
  tipo_label: string;
  documento_version: number;
  expires_at: string | null;
  status: NcpSignatureRequestStatus;
  signing_url: string;
  qr_data_uri: string;
};

export type NcpSignatureRequestProgress = {
  id: number;
  status: NcpSignatureRequestStatus;
  firmada_en: string | null;
  expires_at: string | null;
};

export type PublicNcpSignatureRequest = {
  status: NcpSignatureRequestStatus;
  tipo: CalidadNcpFirmaTipo;
  tipo_label: string;
  numero: number | null;
  documento_version: number;
  expires_at: string | null;
  firmada_en: string | null;
};

export async function createNcpSignatureRequest(
  incidenciaId: number,
  tipo: CalidadNcpFirmaTipo,
): Promise<NcpSignatureRequest> {
  const { data } = await api.post<{ ok: boolean; data: NcpSignatureRequest }>(
    `/certificaciones/iso-9001-14001/incidencias/${incidenciaId}/ficha-ncp/firmas/${tipo}/solicitudes`,
  );

  return data.data;
}

export async function getNcpSignatureRequestProgress(
  incidenciaId: number,
  requestId: number,
): Promise<NcpSignatureRequestProgress> {
  const { data } = await api.get<{ data: NcpSignatureRequestProgress }>(
    `/certificaciones/iso-9001-14001/incidencias/${incidenciaId}/ficha-ncp/firmas/solicitudes/${requestId}`,
  );

  return data.data;
}

export async function getPublicNcpSignatureRequest(
  token: string,
): Promise<PublicNcpSignatureRequest> {
  const { data } = await api.get<{ data: PublicNcpSignatureRequest }>(
    `/certificaciones/public/ncp-firmas/${token}`,
  );

  return data.data;
}

export async function sendPublicNcpSignatureCode(token: string): Promise<string> {
  const { data } = await api.post<{ ok: boolean; message: string }>(
    `/certificaciones/public/ncp-firmas/${token}/codigo`,
  );

  return data.message;
}

export async function signPublicNcpDocument(
  token: string,
  codigo: string,
): Promise<CalidadNcpFirma> {
  const { data } = await api.post<{ ok: boolean; message: string; data: CalidadNcpFirma }>(
    `/certificaciones/public/ncp-firmas/${token}/firmar`,
    { codigo },
  );

  return data.data;
}
